module.exports = __webpack_public_path__ + "img/1566605359.64a8deee.jpg";